import { useDrag } from "react-dnd";
import { useDispatch, useSelector } from "react-redux";
import { FaUserCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { fetchApi } from "../../../utlis/axios";
import { addToast } from "../../../Redux/Slices/toast-slice";
import { useState, useRef, useEffect } from "react";
import loader from "../../../assets/loading-gif.gif";
import { BsThreeDotsVertical } from "react-icons/bs";
import { IoMdTime } from "react-icons/io";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import { IoCalendarClearOutline } from "react-icons/io5";
import { FaExclamation } from "react-icons/fa6";
import { FaRegEdit } from "react-icons/fa";
import { RiDeleteBin6Line } from "react-icons/ri";

const Card = ({
  ticket,
  ticketLoading,
  setTickets,
  tickets,
  handleTicketClick,
  handleEditTicket,
  setIsTicketLoading,
  setTicketModal
}) => {
  const { theme } = useSelector((state) => state.theme);
  const [, drag] = useDrag({
    type: "CARD",
    item: { id: ticket?.id },
  });
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state?.auth || {});
  const dispatch = useDispatch();
  const [updating, setUpdating] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleUpdateCard = async (id) => {
    setUpdating(true);
    try {
      const res = await fetchApi.patch(
        `project-tickets/${id}/`,
        { is_completed: true },
        {
          headers: {
            Authorization: `Bearer ${userInfo.access_token}`,
          },
        }
      );
      if (res.status === 200) {
        setTickets((prevTickets) =>
          prevTickets.map((ticket) =>
            ticket.id === id ? { ...ticket, ...res.data } : ticket
          )
        );
        dispatch(
          addToast({ message: "Ticket marked as completed", type: "success" })
        );
      }
    } catch (error) {
      dispatch(addToast({ message: error.message, type: "error" }));
    } finally {
      setUpdating(false);
    }
  };

  const handleEdit = async () => {
    setIsDropdownOpen(false);
    setTicketModal(true)
    setIsTicketLoading(true)
    try {
      const res = await fetchApi.get(`project-tickets/${ticket.id}/`, {
        headers: {
          Authorization: `Bearer ${userInfo.access_token}`,
        },
      });
      console.log(res.data)
      if (res.status === 200) {
        setIsTicketLoading(false)
        handleEditTicket(res.data);
      }
    } catch (error) {
      dispatch(addToast({ message: error.message, type: "error" }));
    }
  };

  const handleDelete = async () => {
    setIsDropdownOpen(false);
    try {
      const res = await fetchApi.delete(`project-tickets/${ticket.id}/`, {
        headers: {
          Authorization: `Bearer ${userInfo.access_token}`,
        },
      });
      if (res.status === 204) {
        setTickets(tickets.filter((t) => t.id !== ticket.id));
        dispatch(addToast({ message: "Ticket deleted successfully", type: "success" }));
      }
    } catch (error) {
      dispatch(addToast({ message: error.message, type: "error" }));
    }
  };

  const getFileType = (fileName) => {
    if (!fileName) return "other";
    const extension = fileName.split(".").pop().toLowerCase();
    const imageTypes = ["jpg", "jpeg", "png", "gif", "webp"];
    const videoTypes = ["mp4", "webm", "ogg"];
    const pdfType = ["pdf"];

    if (imageTypes.includes(extension)) return "image";
    if (videoTypes.includes(extension)) return "video";
    if (pdfType.includes(extension)) return "pdf";
    return "other";
  };

  const getFirstMediaAttachment = () => {
    if (!ticket?.attachment?.length) return null;
    return ticket?.attachment.find((file) => {
      const fileType = getFileType(file.file);
      return fileType === "image" || fileType === "video";
    });
  };

  const firstMedia = getFirstMediaAttachment();

  return (
    <div
      ref={drag}
      className={`card  rounded-[10px] shadow-md transition-all duration-200
      ${
        theme === "dark" ? "text-white bg-[#212529]" : "text-black bg-white "
      }
      border border-transparent hover:border-red-600 ${!firstMedia ?' p-4': ''}`}
      draggable   
      onClick={(e)=> {
        // Only open popup if we're not clicking on interactive elements
        const isInteractiveElement = e.target.closest('.card-checkbox, .three-dots-menu, .dropdown-menu');
        if (!ticketLoading && !isInteractiveElement) {
          handleTicketClick(ticket?.id);
        }
      }}
    >
      {ticketLoading ? (
        <div className="animate-pulse space-y-3">
          <div
            className={`h-4 bg-gray-500 rounded-md ${
              theme === "dark" ? "bg-gray-600" : "bg-gray-400"
            }`}
          ></div>
          <div
            className={`h-4 bg-gray-500 rounded-md w-3/4 ${
              theme === "dark" ? "bg-gray-600" : "bg-gray-400"
            }`}
          ></div>
          <div
            className={`h-4 bg-gray-500 rounded-md w-1/2 ${
              theme === "dark" ? "bg-gray-600" : "bg-gray-400"
            }`}
          ></div>
        </div>
      ) : (
        <div className="flex w-full justify-between">
          <div className="flex flex-col w-full">
               {/* Show first media attachment if exists */}
               {(() => {
                      const firstMedia = getFirstMediaAttachment();
                      if (!firstMedia) return null;

                      const fileType = getFileType(firstMedia.file);
                      return (
                        <div className="relative w-full h-[120px] rounded-t-[10px] overflow-hidden "
                       >
                          {fileType === "image" ? (
                            <div className="relative w-full h-full group">
                              <img
                                src={firstMedia.file}
                                alt="Attachment preview"
                                className="w-full h-full object-contain"
                              />
                            </div>
                          ) : (
                            <div className="relative w-full h-full">
                              <video
                                src={firstMedia.file}
                                controls
                                className="w-full h-full object-contain"
                              />
                            
                            </div>
                          )}
                        </div>
                      );
                    })()}
                    <div className={`${firstMedia ?' pr-4 pl-4 pt-2 pb-4' :''}`}>
            <div className="flex items-center gap-2 justify-between w-full">
              <div className="flex gap-2 items-center">
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsChecked(!isChecked);
                    handleUpdateCard(ticket?.id);
                  }}
                  className={`w-5 h-5 rounded-md border flex items-center justify-center transition-all duration-200
    ${
      isChecked
        ? "bg-green-600 border-green-600"
        : theme === "dark"
        ? "border-white"
        : "border-black"
    }
    card-checkbox cursor-pointer`}
                  style={{ background: updating ? "transparent" : "", display : updating ? 'block':'' }}
                >
                  {updating ? (
                    <img src={loader} className="w-4 h-4" alt="Loading..." />
                  ) : (
                    isChecked && (
                      <svg
                        className="w-4 h-4 text-white"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="3"
                        viewBox="0 0 24 24"
                      >
                        <path d="M5 13l4 4L19 7" />
                      </svg>
                    )
                  )}
                </div>

                <div
                  className={`py-1 px-2 flex items-center gap-2 rounded-3xl border capitalize text-sm ${
                    ticket?.priority === "low"
                      ? "bg-gray-200 border-gray-600 text-gray-600"
                      : ticket?.priority === "medium"
                      ? "bg-green-200 border-green-600 text-green-600"
                      : "bg-red-200 border-red-600 text-red-600"
                  }`}
                >
                  <div
                    className={`${
                      ticket?.priority === "low"
                        ? "bg-gray-600"
                        : ticket?.priority === "medium"
                        ? "bg-green-600"
                        : "bg-red-600"
                    } rounded p-[2px] rotate-45 `}
                  >
                    <FaExclamation
                      className={`text-white w-3 h-3 rotate-[-45deg]`}
                    />
                  </div>
                  <span className="text-xs">{ticket?.priority}</span>
                </div>
              </div>

              <div className="relative">
                <button 
                  className="outline-none three-dots-menu"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setIsDropdownOpen(!isDropdownOpen);
                  }}
                >
                  <BsThreeDotsVertical className="w-6 h-6" />
                </button>

                {isDropdownOpen && (
                  <div
                    ref={dropdownRef}
                    className={`absolute right-0 mt-2 w-32 z-10 rounded-[10px] shadow-lg border overflow-hidden dropdown-menu
                    ${
                      theme === "dark"
                        ? "bg-[#212529] border-[#555657]"
                        : "bg-[#F2F4F7] border-[#9A9F9A]"
                    }`}
                  >
                    <button
                      className={`w-full text-left px-4 py-2 text-base flex items-center font-medium gap-1 ${
                        theme === "dark"
                          ? "hover:bg-gradient-to-r hover:from-[#fff3] hover:to-[#fff0] transition-all text-white"
                          : "hover:bg-gradient-to-r hover:from-[#6d6d6d33] hover:to-[#fff0] transition-all text-black"
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleEdit();
                      }}
                    >
                      <FaRegEdit className="w-5 h-5"/>
                      Edit
                    </button>
                    <button
                      className={`w-full text-left px-4 py-2 text-base flex gap-1 items-center font-medium text-red-500 ${
                        theme === "dark"
                          ? "hover:bg-gradient-to-r hover:from-[#fff3] hover:to-[#fff0] transition-all"
                          : "hover:bg-gradient-to-r hover:from-[#6d6d6d33] hover:to-[#fff0] transition-all"
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDelete();
                      }}
                    >
                      <RiDeleteBin6Line className="w-5 h-5" />
                      Delete
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div
              className="cursor-pointer"
           
            >
              <div className="flex gap-2 items-center mt-1">
                <span className="text-lg font-medium">{ticket?.title}</span>
              </div>
              <div className="flex mt-1 items-center justify-between">
                <div className="flex gap-2 items-center">
                  <IoCalendarClearOutline />
                  <span className="text-xs">
                    {new Date(ticket?.started_at).toISOString().split("T")[0]}
                  </span>
                </div>

                <div className="flex items-center gap-1">
                  <IoMdTime />
                  {ticket?.time_allotted
}Hrs
                </div>
              </div>
              <div className="mt-1 flex items-center justify-between gap-2 w-full">
                <div className="flex gap-1 items-center text-sm ">
                  {ticket?.developer?.picture ? (
                    <img
                      src={ticket?.developer?.picture}
                      alt="profile"
                      className="w-4 h-4 rounded-full"
                    />
                  ) : (
                    <FaUserCircle className="w-4 h-4 text-gray-500" />
                  )}
                  {ticket?.developer
                    ? ticket?.developer?.first_name +
                      ticket?.developer?.last_name
                    : "Unassigned"}
                </div>
                <div className="flex gap-1 items-center text-sm">
                  <AiOutlineExclamationCircle />
                  {ticket?.type}
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Card;
